import { fmtBRL } from "@/lib/api";
import { CalendarClock, CheckCircle2, Target } from "lucide-react";

const Metric = ({ testid, icon: Icon, label, value, sub, color }) => (
  <div data-testid={testid} className="min-w-0">
    <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-slate-400">
      <Icon className="h-3.5 w-3.5" style={{ color }} /> {label}
    </div>
    <div className="mt-2 text-3xl sm:text-4xl font-extrabold tracking-tight font-mono text-white truncate">{value}</div>
    <div className="mt-1 text-xs text-slate-500">{sub}</div>
  </div>
);

export const HeroToday = ({ today, next }) => {
  const pct = today.forecast_amount ? Math.min(100, Math.round((100 * today.received_amount) / today.forecast_amount)) : 0;
  const dateLabel = new Date(`${today.date}T12:00:00`).toLocaleDateString("pt-BR", { weekday: "long", day: "2-digit", month: "long" });
  return (
    <div data-testid="hero-today-card" className="lg:col-span-7 relative overflow-hidden rounded-2xl border border-[#1F293D] bg-[#111827] p-6 fade-up">
      <div className="pointer-events-none absolute -right-24 -top-24 h-64 w-64 rounded-full bg-emerald-500/10 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-28 left-10 h-56 w-56 rounded-full bg-sky-500/10 blur-3xl" />
      <div className="relative flex items-center justify-between">
        <div>
          <span className="rounded-full border border-emerald-500/30 bg-emerald-500/10 px-2.5 py-0.5 text-[11px] font-bold uppercase tracking-wider text-emerald-300">Hoje</span>
          <p className="mt-2 text-sm capitalize text-slate-400">{dateLabel}</p>
        </div>
      </div>
      <div className="relative mt-5 grid grid-cols-1 gap-6 sm:grid-cols-2">
        <Metric testid="metric-previsto-hoje" icon={CalendarClock} color="#38BDF8" label="Previsto hoje"
          value={fmtBRL(today.forecast_amount)} sub={`${today.forecast_count} logins vencem hoje`} />
        <Metric testid="metric-recebido-hoje" icon={CheckCircle2} color="#34D399" label="Recebido hoje"
          value={fmtBRL(today.received_amount)} sub={`${today.received_count} renovações detectadas`} />
      </div>
      <div data-testid="metric-taxa-hoje" className="relative mt-6">
        <div className="mb-2 flex items-center justify-between text-xs">
          <span className="flex items-center gap-1.5 text-slate-400"><Target className="h-3.5 w-3.5 text-amber-400" /> Realizado do previsto</span>
          <span className="font-mono font-semibold text-slate-200">{pct}%</span>
        </div>
        <div className="h-2.5 w-full overflow-hidden rounded-full bg-[#0F141F] border border-[#1F293D]">
          <div className="h-full rounded-full bg-gradient-to-r from-emerald-500 to-sky-400 transition-[width] duration-700 ease-out" style={{ width: `${pct}%` }} />
        </div>
      </div>
      {next.length > 0 && (
        <div data-testid="hero-next-days" className="relative mt-6 grid grid-cols-1 gap-2 sm:grid-cols-3">
          {next.map((n) => (
            <div key={n.date} className="rounded-xl border border-[#1F293D] bg-[#0F141F]/80 px-3 py-2">
              <div className="text-[11px] uppercase tracking-wider text-slate-500">{n.label} · {n.day}</div>
              <div className="font-mono text-sm font-bold text-slate-100">{fmtBRL(n.forecast_amount)}</div>
              <div className="text-[11px] text-slate-500">{n.forecast_count} logins</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
